import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Archive = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M21.5,3h-19C2.2,3,2,3.2,2,3.5v4C2,7.8,2.2,8,2.5,8H3v12.5C3,20.8,3.2,21,3.5,21h17c0.3,0,0.5-0.2,0.5-0.5V8h0.5
			C21.8,8,22,7.8,22,7.5v-4C22,3.2,21.8,3,21.5,3z M3,7V4h18v3H3z M14.2,8c-0.6,0.6-1.4,1-2.2,1s-1.7-0.4-2.2-1H14.2z M20,20H4V8
			h4.6c0.7,1.2,2,2,3.4,2s2.7-0.8,3.4-2H20V20z"
      />
      <path d="M8,15h8v-3H8V15z M9,13h6v1H9V13z" />
    </g>
  </SvgIcon>
);

export default Archive;
